import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelCheckbox as _vModelCheckbox, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c5baf764"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "invoice-editor p-4 bg-light rounded" }
const _hoisted_2 = { class: "d-flex justify-content-between align-items-center mb-3" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "mb-0" }, "Édition de la facture", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-save mr-1" }, null, -1))
const _hoisted_5 = { class: "row mb-3" }
const _hoisted_6 = { class: "col-md-6" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-form-label" }, "Type de facture", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "definitive" }, "Définitive", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "proforma" }, "Proforma", -1))
const _hoisted_10 = [
  _hoisted_8,
  _hoisted_9
]
const _hoisted_11 = { class: "col-md-6" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-form-label" }, "Date de facturation", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "mt-4" }, "Articles", -1))
const _hoisted_14 = { class: "table table-sm" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "Désignation"),
    /*#__PURE__*/_createElementVNode("th", null, "Quantité"),
    /*#__PURE__*/_createElementVNode("th", null, "Prix unitaire"),
    /*#__PURE__*/_createElementVNode("th")
  ])
], -1))
const _hoisted_16 = ["onUpdate:modelValue"]
const _hoisted_17 = ["onUpdate:modelValue"]
const _hoisted_18 = ["onUpdate:modelValue"]
const _hoisted_19 = ["onClick"]
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-trash" }, null, -1))
const _hoisted_21 = [
  _hoisted_20
]
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-plus mr-1" }, null, -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "mt-4" }, "Descriptions par section", -1))
const _hoisted_24 = ["onUpdate:modelValue"]
const _hoisted_25 = ["onUpdate:modelValue"]
const _hoisted_26 = ["onClick"]
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-trash" }, null, -1))
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-plus mr-1" }, null, -1))
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "mt-4" }, "Options fiscales", -1))
const _hoisted_30 = { class: "form-check" }
const _hoisted_31 = { class: "form-check-label" }
const _hoisted_32 = { class: "form-check" }
const _hoisted_33 = { class: "form-check-label" }
const _hoisted_34 = { class: "form-check" }
const _hoisted_35 = { class: "form-check-label" }
const _hoisted_36 = { class: "text-right mt-4" }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Sous-total :", -1))
const _hoisted_38 = { key: 0 }
const _hoisted_39 = { key: 1 }
const _hoisted_40 = { key: 2 }
const _hoisted_41 = { class: "font-weight-bold" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("button", {
        class: "btn btn-success btn-sm",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.save && _ctx.save(...args)))
      }, [
        _hoisted_4,
        _createTextVNode(" Enregistrer ")
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _hoisted_7,
        _withDirectives(_createElementVNode("select", {
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.localInvoice.type) = $event)),
          class: "form-control"
        }, _hoisted_10, 512), [
          [_vModelSelect, _ctx.localInvoice.type]
        ])
      ]),
      _createElementVNode("div", _hoisted_11, [
        _hoisted_12,
        _withDirectives(_createElementVNode("input", {
          type: "date",
          class: "form-control",
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.localInvoice.issued_at) = $event))
        }, null, 512), [
          [_vModelText, _ctx.localInvoice.issued_at]
        ])
      ])
    ]),
    _hoisted_13,
    _createElementVNode("table", _hoisted_14, [
      _hoisted_15,
      _createElementVNode("tbody", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.localInvoice.items, (item, index) => {
          return (_openBlock(), _createElementBlock("tr", { key: index }, [
            _createElementVNode("td", null, [
              _withDirectives(_createElementVNode("input", {
                class: "form-control",
                "onUpdate:modelValue": ($event: any) => ((item.title) = $event)
              }, null, 8, _hoisted_16), [
                [_vModelText, item.title]
              ])
            ]),
            _createElementVNode("td", null, [
              _withDirectives(_createElementVNode("input", {
                class: "form-control",
                type: "number",
                "onUpdate:modelValue": ($event: any) => ((item.qty) = $event)
              }, null, 8, _hoisted_17), [
                [
                  _vModelText,
                  item.qty,
                  void 0,
                  { number: true }
                ]
              ])
            ]),
            _createElementVNode("td", null, [
              _withDirectives(_createElementVNode("input", {
                class: "form-control",
                type: "number",
                "onUpdate:modelValue": ($event: any) => ((item.price) = $event)
              }, null, 8, _hoisted_18), [
                [
                  _vModelText,
                  item.price,
                  void 0,
                  { number: true }
                ]
              ])
            ]),
            _createElementVNode("td", null, [
              _createElementVNode("button", {
                class: "btn btn-danger btn-sm",
                onClick: ($event: any) => (_ctx.removeItem(index))
              }, _hoisted_21, 8, _hoisted_19)
            ])
          ]))
        }), 128))
      ])
    ]),
    _createElementVNode("button", {
      class: "btn btn-outline-primary btn-sm",
      onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.addItem && _ctx.addItem(...args)))
    }, [
      _hoisted_22,
      _createTextVNode(" Ajouter un article ")
    ]),
    _hoisted_23,
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.localInvoice.description, (desc, index) => {
      return (_openBlock(), _createElementBlock("div", {
        key: index,
        class: "mb-2"
      }, [
        _withDirectives(_createElementVNode("input", {
          class: "form-control mb-1",
          "onUpdate:modelValue": ($event: any) => ((desc.title) = $event),
          placeholder: "Titre de section"
        }, null, 8, _hoisted_24), [
          [_vModelText, desc.title]
        ]),
        _withDirectives(_createElementVNode("textarea", {
          class: "form-control",
          rows: "2",
          "onUpdate:modelValue": ($event: any) => ((desc.content) = $event),
          placeholder: "Contenu..."
        }, null, 8, _hoisted_25), [
          [_vModelText, desc.content]
        ]),
        _createElementVNode("button", {
          class: "btn btn-danger btn-sm mt-1",
          onClick: ($event: any) => (_ctx.removeSection(index))
        }, [
          _hoisted_27,
          _createTextVNode(" Supprimer ")
        ], 8, _hoisted_26)
      ]))
    }), 128)),
    _createElementVNode("button", {
      class: "btn btn-outline-primary btn-sm",
      onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.addSection && _ctx.addSection(...args)))
    }, [
      _hoisted_28,
      _createTextVNode(" Ajouter une section ")
    ]),
    _hoisted_29,
    _createElementVNode("div", _hoisted_30, [
      _createElementVNode("label", _hoisted_31, [
        _withDirectives(_createElementVNode("input", {
          class: "form-check-input",
          type: "checkbox",
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.localOptions.useTVA) = $event))
        }, null, 512), [
          [_vModelCheckbox, _ctx.localOptions.useTVA]
        ]),
        _createTextVNode(" Appliquer TVA (" + _toDisplayString(_ctx.localInvoice.taxes.tva) + "%) ", 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_32, [
      _createElementVNode("label", _hoisted_33, [
        _withDirectives(_createElementVNode("input", {
          class: "form-check-input",
          type: "checkbox",
          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.localOptions.useTPS) = $event))
        }, null, 512), [
          [_vModelCheckbox, _ctx.localOptions.useTPS]
        ]),
        _createTextVNode(" Appliquer TPS (" + _toDisplayString(_ctx.localInvoice.taxes.tps) + "%) ", 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_34, [
      _createElementVNode("label", _hoisted_35, [
        _withDirectives(_createElementVNode("input", {
          class: "form-check-input",
          type: "checkbox",
          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.localOptions.useCSS) = $event))
        }, null, 512), [
          [_vModelCheckbox, _ctx.localOptions.useCSS]
        ]),
        _createTextVNode(" Appliquer CSS (" + _toDisplayString(_ctx.localInvoice.taxes.css) + "%) ", 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_36, [
      _createElementVNode("p", null, [
        _hoisted_37,
        _createTextVNode(" " + _toDisplayString(_ctx.formatCurrency(_ctx.subtotal)), 1)
      ]),
      (_ctx.localOptions.useTVA)
        ? (_openBlock(), _createElementBlock("p", _hoisted_38, [
            _createElementVNode("strong", null, "TVA (" + _toDisplayString(_ctx.localInvoice.taxes.tva) + "%) :", 1),
            _createTextVNode(" " + _toDisplayString(_ctx.formatCurrency(_ctx.tva)), 1)
          ]))
        : _createCommentVNode("", true),
      (_ctx.localOptions.useTPS)
        ? (_openBlock(), _createElementBlock("p", _hoisted_39, [
            _createElementVNode("strong", null, "TPS (" + _toDisplayString(_ctx.localInvoice.taxes.tps) + "%) :", 1),
            _createTextVNode(" " + _toDisplayString(_ctx.formatCurrency(_ctx.tps)), 1)
          ]))
        : _createCommentVNode("", true),
      (_ctx.localOptions.useCSS)
        ? (_openBlock(), _createElementBlock("p", _hoisted_40, [
            _createElementVNode("strong", null, "CSS (" + _toDisplayString(_ctx.localInvoice.taxes.css) + "%) :", 1),
            _createTextVNode(" " + _toDisplayString(_ctx.formatCurrency(_ctx.css)), 1)
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("h5", _hoisted_41, "Total : " + _toDisplayString(_ctx.formatCurrency(_ctx.total)), 1)
    ])
  ]))
}